import apiClient from './client';

// AI Content Generation API
export const contentAPI = {
  // DALL-E Image Generation
  generateImage: (data) => apiClient.post('/content/generate-image', data),
  getImageHistory: (params) => apiClient.get('/content/images/history', { params }),
  
  // HeyGen Video Generation
  getHeyGenAvatars: () => apiClient.get('/content/heygen/avatars'),
  getHeyGenVoices: () => apiClient.get('/content/heygen/voices'),
  generateHeyGenVideo: (data) => apiClient.post('/content/generate-heygen-video', data),
  
  // Runway Video Generation
  generateRunwayVideo: (data) => apiClient.post('/content/generate-runway-video', data),
  
  // Video Status
  getVideoStatus: (videoId) => apiClient.get(`/content/video-status/${videoId}`),
  getVideoHistory: (params) => apiClient.get('/content/videos/history', { params }),
};

export default contentAPI;
